
	import { defineComponent, onMounted, ref, reactive, toRefs } from 'vue'
	import formatDate from '@/common/functions/formatDate'
	import { reviewInfo, review } from '../request'
	import PreviewImage from './PreviewImage.vue'
	export default defineComponent({
		components: {
			PreviewImage
		},
		props: {
			detail: {
				type: Object,
				default: () => {}
			}
		},
		emits: ['close', 'success'],
		setup(props, { emit }) {
			const { detail } = toRefs(props)
			const visible = ref(true)
			const afterClose = () => {
				emit('close')
			}
			const form = reactive<any>({})
			const desc = ref('')
			const mobile = ref('')
			const fetchDetail = async () => {
				try {
					const params = {
						id: detail.value.id
					}
					const { data } = await reviewInfo(params)
					Object.assign(form, data)
					if (detail.value.reviewDesc) {
						desc.value = detail.value.reviewDesc
					}
					mobile.value = data.mobile
					if (form.applyInfo) {
						// 如果申请信息存在
						form.info = JSON.parse(form.applyInfo)
					}
				} catch (error) {
					console.log(error)
				}
			}
			const paramsState = reactive({
				visible: false
			})
			const handleClose = () => {
				paramsState.visible = false
			}
			onMounted(() => {
				if (detail.value) {
					fetchDetail()
				}
			})
			return {
				visible,
				afterClose,
				form,
				desc,
				paramsState,
				handleClose,
				formatDate,
				mobile
			}
		}
	})
